import { render } from "./portfolioCard.vue?vue&type=template&id=4a4685ee"
import script from "./portfolioCard.vue?vue&type=script&lang=js"
export * from "./portfolioCard.vue?vue&type=script&lang=js"

import "./portfolioCard.vue?vue&type=style&index=0&id=4a4685ee&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__